/*------------------------------------
 * Theme: Hunter and Gather
 * File: Main theme scripts file
 * Author: RTNU
 * URI: https://runthenumbersup.com/
 *------------------------------------
 */

/*---------------------------------------
 * Detect User Agent Script
 * http://cssuseragent.org
 *----------------------------------------
 * This is by far the best detection script I've found.
 * Using javascript means that this will work with caching. W00t.
 *
 * Adds user agent classes to the <html> element on your page including OS
 * and browser version.
 *
 */

// prettier-ignore
var cssua=function(n,l,p){var q=/\s*([\-\w ]+)[\s\/\:]([\d_]+\b(?:[\-\._\/]\w+)*)/,r=/([\w\-\.]+[\s\/][v]?[\d_]+\b(?:[\-\._\/]\w+)*)/g,s=/\b(?:(blackberry\w*|bb10)|(rim tablet os))(?:\/(\d+\.\d+(?:\.\w+)*))?/,t=/\bsilk-accelerated=true\b/,u=/\bfluidapp\b/,v=/(\bwindows\b|\bmacintosh\b|\blinux\b|\bunix\b)/,w=/(\bandroid\b|\bipad\b|\bipod\b|\bwindows phone\b|\bwpdesktop\b|\bxblwp7\b|\bzunewp7\b|\bwindows ce\b|\bblackberry\w*|\bbb10\b|\brim tablet os\b|\bmeego|\bwebos\b|\bpalm|\bsymbian|\bj2me\b|\bdocomo\b|\bpda\b|\bchtml\b|\bmidp\b|\bcldc\b|\w*?mobile\w*?|\w*?phone\w*?)/,
  x=/(\bxbox\b|\bplaystation\b|\bnintendo\s+\w+)/,k={parse:function(b,d){var a={};d&&(a.standalone=d);b=(""+b).toLowerCase();if(!b)return a;for(var c,e,g=b.split(/[()]/),f=0,k=g.length;f<k;f++)if(f%2){var m=g[f].split(";");c=0;for(e=m.length;c<e;c++)if(q.exec(m[c])){var h=RegExp.$1.split(" ").join("_"),l=RegExp.$2;if(!a[h]||parseFloat(a[h])<parseFloat(l))a[h]=l}}else if(m=g[f].match(r))for(c=0,e=m.length;c<e;c++)h=m[c].split(/[\/\s]+/),h.length&&"mozilla"!==h[0]&&(a[h[0].split(" ").join("_")]=h.slice(1).join("-"));
  w.exec(b)?(a.mobile=RegExp.$1,s.exec(b)&&(delete a[a.mobile],a.blackberry=a.version||RegExp.$3||RegExp.$2||RegExp.$1,RegExp.$1?a.mobile="blackberry":"0.0.1"===a.version&&(a.blackberry="7.1.0.0"))):x.exec(b)?(a.game=RegExp.$1,c=a.game.split(" ").join("_"),a.version&&!a[c]&&(a[c]=a.version)):v.exec(b)&&(a.desktop=RegExp.$1);a.intel_mac_os_x?(a.mac_os_x=a.intel_mac_os_x.split("_").join("."),delete a.intel_mac_os_x):a.cpu_iphone_os?(a.ios=a.cpu_iphone_os.split("_").join("."),delete a.cpu_iphone_os):a.cpu_os?
  (a.ios=a.cpu_os.split("_").join("."),delete a.cpu_os):"iphone"!==a.mobile||a.ios||(a.ios="1");a.opera&&a.version?(a.opera=a.version,delete a.blackberry):t.exec(b)?a.silk_accelerated=!0:u.exec(b)&&(a.fluidapp=a.version);a.edge&&(delete a.applewebkit,delete a.safari,delete a.chrome,delete a.android);if(a.applewebkit)a.webkit=a.applewebkit,delete a.applewebkit,a.opr&&(a.opera=a.opr,delete a.opr,delete a.chrome),a.safari&&(a.chrome||a.crios||a.fxios||a.opera||a.silk||a.fluidapp||a.phantomjs||a.mobile&&
    !a.ios?(delete a.safari,a.vivaldi&&delete a.chrome):a.safari=a.version&&!a.rim_tablet_os?a.version:{419:"2.0.4",417:"2.0.3",416:"2.0.2",412:"2.0",312:"1.3",125:"1.2",85:"1.0"}[parseInt(a.safari,10)]||a.safari);else if(a.msie||a.trident)if(a.opera||(a.ie=a.msie||a.rv),delete a.msie,delete a.android,a.windows_phone_os)a.windows_phone=a.windows_phone_os,delete a.windows_phone_os;else{if("wpdesktop"===a.mobile||"xblwp7"===a.mobile||"zunewp7"===a.mobile)a.mobile="windows desktop",a.windows_phone=9>+a.ie?
    "7.0":10>+a.ie?"7.5":"8.0",delete a.windows_nt}else if(a.gecko||a.firefox)a.gecko=a.rv;a.rv&&delete a.rv;a.version&&delete a.version;return a},format:function(b){var d="",a;for(a in b)if(a&&b.hasOwnProperty(a)){var c=a,e=b[a],c=c.split(".").join("-"),g=" ua-"+c;if("string"===typeof e){for(var e=e.split(" ").join("_").split(".").join("-"),f=e.indexOf("-");0<f;)g+=" ua-"+c+"-"+e.substring(0,f),f=e.indexOf("-",f+1);g+=" ua-"+c+"-"+e}d+=g}return d},encode:function(b){var d="",a;for(a in b)a&&b.hasOwnProperty(a)&&
    (d&&(d+="\x26"),d+=encodeURIComponent(a)+"\x3d"+encodeURIComponent(b[a]));return d}};k.userAgent=k.ua=k.parse(l,p);l=k.format(k.ua)+" js";n.className=n.className?n.className.replace(/\bno-js\b/g,"")+l:l.substr(1);return k}(document.documentElement,navigator.userAgent,navigator.standalone);

/*
 * Get Viewport Dimensions
 * returns object with viewport dimensions to match css in width and height properties
 * ( source: http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript )
 */
// prettier-ignore
function updateViewportDimensions() {
var w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
return { width:x,height:y };
}
// setting the viewport width
var viewport = updateViewportDimensions();

/*
 * Throttle Resize-triggered Events
 * Wrap your actions in this function to throttle the frequency of firing them off, for better performance, esp. on mobile.
 * ( source: http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed )
 */
// prettier-ignore
var waitForFinalEvent = (function () {
var timers = {};
return function (callback, ms, uniqueId) {
  if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
  if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
  timers[uniqueId] = setTimeout(callback, ms);
};
})();

// how long to wait before deciding the resize has stopped, in ms. Around 50-100 should work ok.
var timeToWaitForLast = 100;

/*
 * Here's an example so you can see how we're using the above function
 *
 * This is commented out so it won't work, but you can copy it and
 * remove the comments.
 *
 *
 *
 * If we want to only do it on a certain page, we can setup checks so we do it
 * as efficient as possible.
 *
 * if( typeof is_home === "undefined" ) var is_home = $('body').hasClass('home');
 *
 * This once checks to see if you're on the home page based on the body class
 * We can then use that check to perform actions on the home page only
 *
 * When the window is resized, we perform this function
 * $(window).resize(function () {
 *
 *    // if we're on the home page, we wait the set amount (in function above) then fire the function
 *    if( is_home ) { waitForFinalEvent( function() {
 *
 *	// update the viewport, in case the window size has changed
 *	viewport = updateViewportDimensions();
 *
 *      // if we're above or equal to 768 fire this off
 *      if( viewport.width >= 768 ) {
 *        console.log('On home page and window sized to 768 width or more.');
 *      } else {
 *        // otherwise, let's do this instead
 *        console.log('Not on home page, or window sized to less than 768.');
 *      }
 *
 *    }, timeToWaitForLast, "your-function-identifier-string"); }
 * });
 *
 */

/*!
 * jQuery Accordion 0.0.1
 * (c) 2014 Victor Fernandez <victor@vctrfrnndz.com>
 * MIT Licensed.
 */
!(function (E, H, x, t) {
  var e = "accordion",
    a = {
      transitionSpeed: 300,
      transitionEasing: "ease",
      controlElement: "[data-control]",
      contentElement: "[data-content]",
      groupElement: "[data-accordion-group]",
      singleOpen: !0,
    };
  function n(t, n) {
    (this.element = t),
      (this.options = E.extend({}, a, n)),
      (this._defaults = a),
      (this._name = e),
      this.init();
  }
  (n.prototype.init = function () {
    var e,
      a,
      i,
      o,
      r = this.options,
      n = E(this.element),
      t = n.find("> " + r.controlElement),
      s = n.find("> " + r.contentElement),
      c = 0 < n.parents("[data-accordion]").length,
      d = { "max-height": 0, overflow: "hidden" },
      h = (function () {
        var t = (x.body || x.documentElement).style,
          n = "transition";
        if ("string" == typeof t[n]) return !0;
        var e = ["Moz", "webkit", "Webkit", "Khtml", "O", "ms"];
        n = "Transition";
        for (var a = 0; a < e.length; a++)
          if ("string" == typeof t[e[a] + n]) return !0;
        return !1;
      })();
    function l(t, n) {
      n
        ? s.css({ "-webkit-transition": "", transition: "" })
        : s.css({
            "-webkit-transition":
              "max-height " + r.transitionSpeed + "ms " + r.transitionEasing,
            transition:
              "max-height " + r.transitionSpeed + "ms " + r.transitionEasing,
          });
    }
    function f(t) {
      var n = 0;
      t.children().each(function () {
        n += E(this).outerHeight(!0);
      }),
        t.data("oHeight", n);
    }
    function m(t, n, e, a) {
      var i,
        o = t.filter(".open").find("> [data-content]"),
        s = o.find("[data-accordion].open > [data-content]");
      r.singleOpen ||
        (s = s.not(
          n.siblings("[data-accordion].open").find("> [data-content]")
        )),
        (i = o.add(s)),
        t.hasClass("open") &&
          i.each(function () {
            var t = E(this).data("oHeight");
            switch (a) {
              case "+":
                E(this).data("oHeight", t + e);
                break;
              case "-":
                E(this).data("oHeight", t - e);
                break;
              default:
                throw "updateParentHeight method needs an operation";
            }
            E(this).css("max-height", E(this).data("oHeight"));
          });
    }
    function g(t) {
      if (t.hasClass("open")) {
        var n = t.find("> [data-content]"),
          e = n.find("[data-accordion].open > [data-content]"),
          a = n.add(e);
        f(a), a.css("max-height", a.data("oHeight"));
      }
    }
    function u(t, n) {
      if ((t.trigger("accordion.close"), h)) {
        if (c) m(t.parents("[data-accordion]"), t, n.data("oHeight"), "-");
        n.css(d), t.removeClass("open");
      } else
        n.css("max-height", n.data("oHeight")),
          n.animate(d, r.transitionSpeed),
          t.removeClass("open");
    }
    function p(t, n) {
      if ((t.trigger("accordion.open"), h)) {
        if ((l(), c))
          m(t.parents("[data-accordion]"), t, n.data("oHeight"), "+");
        (e = function () {
          n.css("max-height", n.data("oHeight"));
        }),
          H.requestAnimationFrame
            ? requestAnimationFrame(e)
            : H.webkitRequestAnimationFrame
            ? webkitRequestAnimationFrame(e)
            : H.mozRequestAnimationFrame
            ? mozRequestAnimationFrame(e)
            : setTimeout(e, 1e3 / 60),
          t.addClass("open");
      } else
        n.animate(
          { "max-height": n.data("oHeight") },
          r.transitionSpeed,
          function () {
            n.css({ "max-height": "none" });
          }
        ),
          t.addClass("open");
      var e;
    }
    function v() {
      var t = !!r.singleOpen && 0 < n.parents(r.groupElement).length;
      f(s),
        t &&
          (function (t) {
            t.closest(r.groupElement);
            var n = t.siblings("[data-accordion]").filter(".open"),
              e = n.find("[data-accordion]").filter(".open"),
              a = n.add(e);
            a.each(function () {
              var t = E(this);
              u(t, t.find(r.contentElement));
            }),
              a.removeClass("open");
          })(n),
        n.hasClass("open") ? u(n, s) : p(n, s);
    }
    s.each(function () {
      var t = E(this);
      0 != t.css("max-height") &&
        (t.closest("[data-accordion]").hasClass("open")
          ? (l(), f(t), t.css("max-height", t.data("oHeight")))
          : t.css({ "max-height": 0, overflow: "hidden" }));
    }),
      n.attr("data-accordion") ||
        (n.attr("data-accordion", ""),
        n.find(r.controlElement).attr("data-control", ""),
        n.find(r.contentElement).attr("data-content", "")),
      t.on("click", v),
      t.on("accordion.toggle", function () {
        if (r.singleOpen && 1 < t.length) return !1;
        v();
      }),
      t.on("accordion.refresh", function () {
        g(n);
      }),
      E(H).on(
        "resize",
        ((e = function () {
          g(n);
        }),
        function () {
          var t = this,
            n = arguments;
          o ? clearTimeout(o) : i && e.apply(t, n),
            (o = setTimeout(function () {
              i || e.apply(t, n), (o = null);
            }, a || 100));
        })
      );
  }),
    (E.fn[e] = function (t) {
      return this.each(function () {
        E.data(this, "plugin_" + e) ||
          E.data(this, "plugin_" + e, new n(this, t));
      });
    });
})(jQuery, window, document);

$(function () {
  $(".accordion").accordion({
    singleOpen: false,
  });

  $(".qtyplus").click(function (e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    var fieldName = $(this).attr("field");
    // Get its current value
    var currentVal = parseInt($("input[id=" + fieldName + "]").val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $("input[id=" + fieldName + "]").val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $("input[id=" + fieldName + "]").val(0);
    }
  });
  // This button will decrement the value till 0
  $(".qtyminus").click(function (e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    var fieldName = $(this).attr("field");
    // Get its current value
    var currentVal = parseInt($("input[id=" + fieldName + "]").val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 1) {
      // Decrement one
      $("input[id=" + fieldName + "]").val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $("input[id=" + fieldName + "]").val(1);
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  /**
   * Fixes vh unit in touch devices
   *
   * @since 1.0
   */
  const setupVh = () => {
    const setVh = () => {
      // get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01;

      // set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty(`--vh`, `${vh}px`);
    };

    setVh();
    window.addEventListener(`resize`, setVh, false);
  };

  /**
   * Chocks away!
   */
  setupVh();

  // Throttle function
  const throttle = (func, limit) => {
    let lastFunc;
    let lastRan;
    return function () {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (Date.now() - lastRan >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  };

  /**
   *
   * These are the variables that will be updated with the resize event
   */

  // Navigation setup
  let topBarHeight, headerHeight, topBarAndHeaderHeight;
  const sectionHeader = document.getElementById("shopify-section-header"),
    topBar = document.querySelector(".rtnu-announcement-bar"),
    rtnuHeader = document.querySelector(".rtnu-header");

  // Function to get and set the heights of the header
  let setHeaderHeights = function () {
    topBarHeight = document.querySelector(
      ".rtnu-announcement-bar"
    ).offsetHeight;

    headerHeightDesktop = document.querySelector(".rtnu-header__desktop").offsetHeight;
    headerHeightMobile = document.querySelector(".rtnu-header__mobile").offsetHeight;

    topBarAndHeaderHeight = topBarHeight + headerHeightDesktop + headerHeightMobile;

    document.documentElement.style.setProperty(
      `--topbar-height`,
      `${topBarHeight}px`
    );
    document.documentElement.style.setProperty(
      `--header-height`,
      `${headerHeight}px`
    );
    document.documentElement.style.setProperty(
      `--topbar-and-header-height`,
      `${topBarAndHeaderHeight}px`
    );
  };

  // Invoke function to get the topbar height
  setHeaderHeights();

  // Set body padding
  if (
    document.body.classList.contains("template-blog") ||
    document.body.classList.contains("template-article")
  ) {
    if (typeof topBar != "undefined" && topBar != null) {
      document.body.style.setProperty(`--padding-top`, `194px`);
    } else {
      document.body.style.setProperty(`--padding-top`, `128px`);
    }

    if (window.innerWidth < 768) {
      if (typeof topBar != "undefined" && topBar != null) {
        document.body.style.setProperty(`--padding-top`, `130px`);
      } else {
        document.body.style.setProperty(`--padding-top`, `88px`);
      }
    }
  }

  // On resize events to recalculate
  window.addEventListener(
    "resize",
    throttle(function () {
      setHeaderHeights();

      if (
        document.body.classList.contains("template-blog") ||
        document.body.classList.contains("template-article")
      ) {
        if (window.innerWidth < 768) {
          if (typeof topBar != "undefined" && topBar != null) {
            document.body.style.setProperty(`--padding-top`, `130px`);
          } else {
            document.body.style.setProperty(`--padding-top`, `88px`);
          }
        } else {
          if (typeof topBar != "undefined" && topBar != null) {
            document.body.style.setProperty(`--padding-top`, `194px`);
          } else {
            document.body.style.setProperty(`--padding-top`, `128px`);
          }
        }
      }
    }, 250),
    false
  );

  let scrollEvents = () => {
    if (typeof topBar != "undefined" && topBar != null) {
      rtnuHeader.parentElement.classList.toggle(
        "shopify-section-header-sticky",
        window.scrollY > topBarHeight
      );
    } else {
      rtnuHeader.parentElement.classList.toggle(
        "shopify-section-header-sticky",
        window.scrollY > 0
      );
    }

    setHeaderHeights();
  };

  // Watch for scroll
  window.addEventListener(
    "scroll",
    throttle(function () {
      scrollEvents();
    }, 50),
    false
  );

  // Intersection Observer to add animations

  // Define the elements you want to intiate an action on
  let observedElements = document.querySelectorAll(".inview-element");

  //define your options
  const options = {
    threshold: 0.25, //25% of the element in view
  };

  const inViewCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // define the event/property you want to use
        entry.target.classList.add("inview");

        // remove the transition delay so other animations can run
        setTimeout(() => {
          entry.target.style.transitionDelay = "0s";
        }, 400);
      }
    });
  };

  // create a new instance using our callback which contains our elements and actions, using the options we defined
  let observer = new IntersectionObserver(inViewCallback, options);

  observedElements.forEach((element) => {
    let dataDelay = element.getAttribute("data-delay");

    element.style.transitionDelay = dataDelay + "ms";
    observer.observe(element); // run the observer
  });

  // Function to unobserve element to prevent playing animation twice
  function handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        observer.unobserve(entry.target);
      }
    });
  }

  // accordion
  const accordionItems = document.querySelectorAll(".rtnu__accordion-item");

  function toggleAccordionItem(event) {
    const accordionItemHeader = event.target.closest(
      ".rtnu__accordion-item-toggle"
    );
    if (!accordionItemHeader) return;

    const accordionItem = accordionItemHeader.parentNode;
    const accordionItemContent = accordionItem.querySelector(
      ".rtnu__accordion-item-content"
    );
    if (!accordionItemContent) return;

    const isOpen = accordionItem.classList.toggle("is-open");

    const maxHeight = isOpen ? accordionItemContent.scrollHeight + "px" : "0";

    accordionItemContent.style.maxHeight = maxHeight;

    accordionItemHeader.setAttribute("aria-expanded", isOpen);
  }

  accordionItems.forEach((item) => {
    const header = item.querySelector(".rtnu__accordion-item-toggle");
    header.addEventListener("click", toggleAccordionItem);
    header.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        // Respond to "Enter" or "Space" key
        event.preventDefault();
        toggleAccordionItem(event);
      }
    });
  });
});